import {useDev, useAxios, AxiosErrorDataModel} from '@sttedra_ui/framework';

/**
 * @typedef {import("@sttedra_ui/framework").AxiosErrorDataModel} AxiosErrorDataModel
 */

// #region Globals
const CONTEXT_BASE_PATH = 'WPS';
const {calc} = useAxios();
// #endregion

const DEFAULT_OBJECT_POINT_REQUEST = {
  point: {
    lat: 0,
    lon: 0,
  },
  srid: 25830,
  height: 0,
  tokenCaptcha: '',
  geoJSON: '',
  affectedTown: '',
};

const DEFAULT_OBJECT_POLYGONS_REQUEST = {
  polygons: [{
    lat: 0,
    lon: 0,
  }],
  srid: 25830,
  height: 0,
  tokenCaptcha: '',
  area: '',
  geoJSON: '',
  affectedTowns: [],
};

// It don't has the area
const DEFAULT_OBJECT_TOWNS_REQUEST = {
  polygons: [{
    lat: 0,
    lon: 0,
  }],
  srid: 25830,
  height: 0,
  tokenCaptcha: '',
  geoJSON: '',
};

// #region Private functions
function getCorrectObject(obj, objRequest) {
  Object.keys(obj).forEach((key) => {
    if (objRequest[key] !== undefined && obj[key] !== null) {
      objRequest[key] = obj[key];
    }
  });
  return objRequest;
}
// #endregion

// #region Public functions
async function getAllInfoByPoint(
  obj = DEFAULT_OBJECT_POINT_REQUEST,
) {
  const objRequest = getCorrectObject(obj, DEFAULT_OBJECT_POINT_REQUEST);

  try {
    const url = `/${CONTEXT_BASE_PATH}/GetAllInfoByPoint`;

    const {data} = await calc
      .post(url, objRequest);

    return data;
  } catch (err) {
    return catchError(err);
  }
}

async function getAllInfoByPolygon(
  obj = DEFAULT_OBJECT_POLYGONS_REQUEST,
) {
  const objRequest = getCorrectObject(obj, DEFAULT_OBJECT_POLYGONS_REQUEST);

  try {
    const url = `/${CONTEXT_BASE_PATH}/GetAllInfoByPolygon`;

    const {data} = await calc
      .post(url, objRequest);

    return data;
  } catch (err) {
    return catchError(err);
  }
}

async function getAllInfoByTown(
  obj = DEFAULT_OBJECT_TOWNS_REQUEST,
) {
  const objRequest = DEFAULT_OBJECT_TOWNS_REQUEST;

  Object.keys(obj).forEach((key) => {
    if (objRequest[key] !== undefined) {
      objRequest[key] = obj[key];
    }
  });

  try {
    const url = `/${CONTEXT_BASE_PATH}/GetAllInfoByTown`;

    const {data} = await calc
      .post(url, objRequest);

    return data;
  } catch (err) {
    return catchError(err);
  }
}

// #endregion


// #region Private functions
/**
 *
 * @param {AxiosErrorDataModel} errorModel
 * @returns
 */
function catchError(errorModel) {
  if (!(errorModel instanceof AxiosErrorDataModel)) {
    throw new Error(errorModel);
  }

  useDev.error(
    errorModel.errors
      .reduce((acc, e) => acc + `(${e.code}) ${e.type}: ${e.message}`,
        `[example.api] Errors:\n`),
  );
}
// #endregion

export {
  getAllInfoByPoint,
  getAllInfoByPolygon,
  getAllInfoByTown,
};
